import { resetStateToDefault, promiseTimeout } from '../../utils'
import { API } from '../../services'
import router from '../../router/router'
import swal from 'sweetalert2'

const KINDS_NAMES = {
  start: 'Entrada',
  stPause: 'Pausa',
  endPause: 'Retorno Pausa',
  end: 'Saída',
}

export const GEO_LOCATION_ERRORS = {
  permissionDenied: 'PERMISSION_DENIED',
  positionUnavailable: 'POSITION_UNAVAILABLE',
  timeout: 'TIMEOUT',
  unknowError: 'UNKNOWN_ERROR'
}

export const RECAPTCH_PUBLIC = '6Ldlu3AUAAAAAHw-GpMcakb-5GnOaolZcEXH7j58'

function defaultState () {
  return {
    retry: 0,
    fallback: false,
    kind: null,
    processing: false,
    coordinates: null,
    screenTimeout: null,
    monthPts: [],
    todayPts: {entrada:[], pausa: [], retorno: [], saida: []},
    employee: null,
    audio: null,
    recordVoice: null,
    sessionToken: null,
    doubleCheck: null,
    noGeoLocationSupport: false,
    geoLocationError: null,
    recaptcha: false,
    token: null
  }
}

const mutations = {
  resetState (state, resetAll = false) {
    const toReset = defaultState()
    if (!resetAll) {
      // reset all fields but not employee, it is seted in password view
      delete toReset['employee']
      delete toReset['sessionToken']
      delete toReset['recordVoice']
      delete toReset['doubleCheck']
      delete toReset['todayPts']
      delete toReset['monthPts']
      delete toReset['fallback']
      delete toReset['retry']
      delete toReset['screenTimeout']
      delete toReset['token']
      delete toReset['recaptcha']
    }
    resetStateToDefault(state, toReset)
  },
  noGeoLocationSupport (state, payload) {
    state.noGeoLocationSupport = Boolean(payload)
  },
  retry (state, payload) {
    state.retry = payload
  },
  processing (state, payload) {
    state.processing = Boolean(payload)
  },
  screenTimeout (state, payload) {
    state.screenTimeout = payload
  },
  geoLocationError (state, payload) {
    state.geoLocationError = payload
  },
  kind (state, kind) {
    if (!['start', 'stPause', 'endPause', 'end'. includes(kind)]) {
      throw new Error("Invalid param to punchTimeLog method")
    }
    state.kind = kind
  },
  coordinates (state, payload) {
    state.coordinates = payload
  },
  token (state, payload) {
    state.token = payload
  },
  recaptcha (state, payload) {
    state.recaptcha = payload
  },
  audio (state, audio) {
    state.audio = audio
  },
  employee (state, empInfo) {
    if (empInfo) {
      state.employee = {id: empInfo.id, name: empInfo.name, pwd: empInfo.pwd, nickname: empInfo.nickname, employer: empInfo.employer}
    } else {
      state.employee = null
    }
  },
  todayPts (state, {entrada, pausa, retorno, saida}) {
    state.todayPts = {entrada, pausa, retorno, saida}
  },
  monthPts (state, monthPts) {
    state.monthPts = monthPts
  },
  recordVoice (state, value) {
    state.recordVoice = Boolean(value)
  },
  sessionToken (state, value) {
    state.sessionToken = value
  },
  doubleCheck (state, value) {
    state.doubleCheck = Boolean(value)
  },
  fallback (state, value) {
    state.fallback = Boolean(value)
  }
}

const actions = {
  async redirectTo({}, url){
    router.push({ name: url })
  },
  async clearScreenTimeout({state}) {
    clearTimeout(state.screenTimeout)
  },
  async saveTimelog ({}, params) {
    // console.log('normal!')
    // return  new Promise((resolve, reject) => {
    //   reject('timeout')
    // })
    return await API.saveTimeLog.save(params)
  },
  async saveFallback ({}, params) {
    // console.log('fallback normal!')
    // return  new Promise((resolve, reject) => {
    //   reject('timeout')
    // })
    return await API.saveFallback.save(params)
  },
  async saveNewFallback ({}, params) {
    // console.log('fallback novo!')
    // return  new Promise((resolve, reject) => {
    //   reject('timeout')
    // })
    return await API.saveNewFallback.save(params)
  },
  async failedSwal ({state, rootState, commit}, message) {
    await swal({
      type: 'error',
      title: 'Atenção',
      text: message,
      confirmButtonText: 'Ok'
    })
    commit('resetState', true)
    router.push({ name: 'password' })
  },
  async resultSwal ({state, rootState, commit}, {result, kind}) {
    if (rootState.accessData.compMan.id === '56d7358536a3b600dc7e2b3e' && ['start', 'end'].includes(kind)) {
      await swal({
        type: 'success',
        title: result.data.success,
        html: '<a href="https://goo.gl/eNaUyU" target="_blank">Como vc esta se sentindo hj?</a>',
        confirmButtonText: 'Ok'
      })
      commit('resetState', true)
      router.push({ name: 'password' })
    } else {
      swal({
        type: 'success',
        text: result.data.success,
        confirmButtonText: 'Ok'
      }).then(_ => {
        commit('resetState', true)
        router.push({ name: 'password' })
      })

      document.querySelector('.swal2-container.swal2-center.swal2-fade.swal2-shown').setAttribute('id', 'salvandoponto')
      document.querySelector('.swal2-confirm.swal2-styled').setAttribute('id', 'pontoregistrado')
    }
  },
  async dealSavetimelogPromise ({dispatch}, {promise, kind, formData, newData, retry}) {

    try {
      const result = await promise;
      dispatch('resultSwal', {result, kind})
    } catch (error) {
      if (error === 'timeout' || error.status === 0) {
        // Falhou uma vez o normal, já tenta o FALLBACK
        try {
          await dispatch('dealFallbackPromise', {
            promise: dispatch('saveNewFallback', newData),
            formData: formData,
            newData: newData,
            retry: 0,
            novoFallback: true
          })
        } catch (e) {
          await dispatch('dealFallbackPromise', {
            promise: dispatch('saveFallback', newData),
            formData: formData,
            newData: newData,
            retry: 0
          })
        }
      } else if (error.status === 401) {
        dispatch('failedSwal', error.body.unauthorized + '. Ponto não registrado!')
      } else {
        dispatch('failedSwal', error.body.error)
      }
    }
  },
  async dealFallbackPromise ({dispatch}, {promise, kind, formData, newData, retry, novoFallback}) {

    try {
      const result = await promise
      dispatch('resultSwal', {result, kind})
    } catch (error) {
      if (error === 'timeout' || error.status === 0) {
        // FALLBACK VAI TENTAR 3 VEZES
        if (retry < 2) {
          dispatch('dealFallbackPromise', {
            promise: dispatch(novoFallback ? 'saveNewFallback' : 'saveFallback', newData),
            kind: kind,
            formData: formData,
            newData: newData,
            retry: retry+1,
            novoFallback: novoFallback
          })
        } else {
          if (!novoFallback) {
            dispatch('failedSwal', 'Falha ao registrar seu ponto.\n Por favor, tente realizar o processo novamente.')
          }
        }
      } else {
        dispatch('resultSwal', {error, kind})
      }
    }

    await promise.then(result => {
      dispatch('resultSwal', {result})
    })
  },
  async preProcessToSaveTimelog ({ state, rootState, commit, dispatch }) {
    commit('processing', true);

    try {

      let formData = new FormData();
      let newData = {};


      if (state.recaptcha && state.token) {
        formData.append('recaptcha', state.token)
      }

      if (state.coordinates) {
        formData.append('lat', state.coordinates.lat);
        formData.append('lon', state.coordinates.lon);

        newData.lon = state.coordinates.lon;
        newData.lat = state.coordinates.lat;
      }

      formData.append('kind', KINDS_NAMES[state.kind]);
      formData.append('fingerprint', rootState.accessData.browserRecord.id);

      if ( state.employee && state.employee.id) {
        formData.append('employee', state.employee.id)
      }

      formData.append('sessionToken', state.sessionToken)

      newData.kind = KINDS_NAMES[state.kind];
      newData.fingerprint = rootState.accessData.browserRecord.id;
      newData.compman = rootState.accessData.compMan.id
      newData.pwd = rootState.password.pwd

      if (state.audio) {
        const blob = state.audio
        blob.lastModifiedDate = new Date();
        blob.name = 'voice.mp3';
        formData.append('audio', blob);
      }

      if (state.fallback) {
        console.log('fallback => fallback')
        try {
          await dispatch('dealFallbackPromise', {
            promise: dispatch('saveNewFallback', newData),
            formData: formData,
            newData: newData,
            retry: 0,
            novoFallback: true
          })
        } catch (e) {
          await dispatch('dealFallbackPromise', {
            promise: dispatch('saveFallback', newData),
            formData: formData,
            newData: newData,
            retry: 0
          })
        }
      } else {
        console.log('normal => normal')
        dispatch('dealSavetimelogPromise', {
          promise: promiseTimeout(5000, dispatch('saveTimelog', formData)),
          kind: state.kind,
          formData: formData,
          newData: newData,
          retry: 0
        })
      }
    } catch (e) {
      console.error('sendForm error', e)
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  actions,
  mutations
}
